import React from "react";
import Table from "../../Common/Table";
import { useHistory } from "react-router-dom";

import TableFields from "../../../constants/Locality/TableFields.json";
import { getPath } from "../../../utils";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import { Pill } from "../../../constants/assets/containers";

const LocalityList = (props) => {
  const history = useHistory();
  const { localityList } = props;
  const allActions = MenuActionsMappings[MenuNames.LOCALITY];

  const getFieldValue = (locality, key) => {
    switch (key) {
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.UPDATE, allActions.DETAIL]}
            notAllowedText="No Allowed Actions"
          >
            <span
              onClick={() => history.push(`/localities/${locality.id}`)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      case "is_pickup_serviceable":
      case "pickup_users_available":
      case "locality_supported":
        return (
          <Pill isFalse={!getPath(locality, key, undefined)}>
            {getPath(locality, key, undefined) ? "Yes" : "No"}
          </Pill>
        );
      default:
        return getPath(locality, key, "");
    }
  };

  return (
    <Table
      list={localityList}
      getFieldValue={getFieldValue}
      fields={TableFields}
    />
  );
};

export default LocalityList;
